export default __webpack_public_path__ + "static/media/sunset_cloud_sea.c775364d.jpg";